import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getDirection } from '@insolech/i18n';

export function useDirectionEffect(): void {
  const { i18n } = useTranslation();
  useEffect(() => {
    const dir = getDirection(i18n.language);
    document.documentElement.dir = dir;
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);
}
